import axiosInstance from './axiosInstance';
import { ClassData, StudentData } from '../types/classTypes';
import { ApiResponse } from '../types/apiTypes';
// Fetch all classes
export const getClasses = async (
  section?: string | undefined // Add `level` as an optional parameter
): Promise<ClassData[]> => {
  const params: any = {}; // Initialize an empty params object

  if (typeof section !== 'undefined') {
    params.section = section;
  }

  const response = await axiosInstance.get<ApiResponse<ClassData[]>>('/classes', { params });
  return response.data.data; // Return only the data array
};

// Fetch a single class by ID
export const getClassById = async (id: string): Promise<ClassData> => {
  const response = await axiosInstance.get<ApiResponse<ClassData>>(`/classes/${id}`);
  return response.data.data;
};

// Create a new class
export const addClass = async (classData: Partial<ClassData>): Promise<ClassData> => {
  const response = await axiosInstance.post<ApiResponse<ClassData>>('/classes', classData);
  return response.data.data;
};

// Update an existing class
export const updateClass = async (id: string, classData: Partial<ClassData>): Promise<ClassData> => {
  const response = await axiosInstance.put<ApiResponse<ClassData>>(`/classes/${id}`, classData);
  return response.data.data;
};

// Delete a class
export const deleteClass = async (id: string): Promise<void> => {
  const response = await axiosInstance.delete(`/classes/${id}`);
  return response.data;
};

// Assign students to a class
export const assignStudentsToClass = async (classId: string, studentIds: string[]): Promise<void> => {
  const response = await axiosInstance.post(`/classes/${classId}/assign-students`, { studentIds });
  return response.data;
};

export const getAssignedStudents = async (classId: string) => {
    const response = await axiosInstance.get<ApiResponse<StudentData[]>>(`/classes/${classId}/students`);
    return response.data.data;
  };

export const getClassesByInstance = async (
  params : any
): Promise<ApiResponse<ClassData[]>> => {
  const response = await axiosInstance.get<ApiResponse<ClassData[]>>('/classes/with-pagination', { params });
  return response.data; 
};  
